/**
 * Returns whether the current page hydrated from server-rendered markup.
 *
 * `window.ssr` is the linchpin flag the SSR renderer injects into the initial document when it
 * sent server-rendered markup. It is the same signal the app bootstrap keys off to choose
 * `hydrateRoot` vs `createRoot` (see bundles/page/lib/appStarterFactory), so it is the
 * authoritative indicator of an SSR'd page load vs a full-CSR one.
 *
 * Read behind a `typeof window` guard so this module is safe to import from code that also runs
 * during SSR (where `window` is undefined). On the server there is no SSR markup to detect, so it
 * returns false. Wrapped in its own util so it can be mocked in tests without poking the global
 * `window` object.
 */
export default function pageWasServerRendered(): boolean {
  // `ssr` is not declared on the global Window type, so cast locally rather than augmenting Window globally.
  return typeof window !== 'undefined' && Boolean((window as typeof window & { ssr?: boolean }).ssr);
}
